/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/. */

export default {
    0x0000: {
        'name': 'PentaxVersion',
        'description': (value) => value.join('.')
    },
    0x0005: 'PentaxModelID',
    0x022b: 'LevelInfo'
};
